import {withProps, withStateHandlers} from 'recompose';
import {form, validate, formProps} from 'lib';
import {
  MainTitle,
  Submit,
  LogoGold,
  TextInput,
  FieldContainer,
  FormContainer,
  Container,
  FormSuccess,
  colors,
} from 'ui';
import {mutate} from 'api';
import {LoginBackground, LoginMask} from './styles';
import {withRouter} from 'react-router';
import ForgotPasswordModal from './ForgotPasswordModal';

const Login = ({
  values,
  requestError,
  errors,
  handleChange,
  handleSubmit,
  setFieldValue,
  mutationLoading,
  confirmRegister,
  showForgotPassword,
  openForgotPassword,
  closeForgotPassword,
}) => {
  const hasLoginError = /invalid_username|invalid_email|incorrect_password|account_not_validated/.test(
    requestError,
  );
  return (
    <Container>
      <LoginBackground>
        <LoginMask>
          <FormContainer onSubmit={handleSubmit} style={{padding: '0 20px', boxSizing: 'border-box'}}>
            <LogoGold />
            <MainTitle
              style={{
                marginBottom: 40,
              }}>
              Connectez-vous
            </MainTitle>
            {confirmRegister && (
              <FormSuccess>
                Merci, votre inscription a bien
                <br /> été prise en compte.
              </FormSuccess>
            )}
            <FieldContainer style={{width: '100%'}}>
              <TextInput
                color="white"
                hasError={hasLoginError}
                id="username"
                label="Adresse email"
                value={values.username}
                error={errors.username}
                onChange={handleChange('username')}
              />
              <TextInput
                color="white"
                hasError={hasLoginError}
                id="password"
                label="Mot de passe"
                value={values.password}
                error={errors.password}
                onChange={handleChange('password')}
                type="password"
              />
              {hasLoginError && (
                <div style={{textAlign: 'center', width: '100%', marginBottom: 16}}>
                  <div style={{color: '#fff', fontSize: 12, marginBottom: 4}}>
                    Adresse email et/ou mot de passe invalide(s)
                  </div>
                  <div style={{color: '#fff', fontSize: 12, fontStyle: 'italic'}}>
                    Si vous venez de vous inscrire, vous devez attendre
                    <br />
                    la validation de votre compte.
                  </div>
                </div>
              )}
              <label
                htmlFor="rememberMe"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                  color: '#fff',
                  fontSize: 14,
                }}>
                <input
                  type="checkbox"
                  id="rememberMe"
                  checked={values.rememberMe}
                  onChange={e => setFieldValue('rememberMe', e.target.checked)}
                  style={{display: 'none'}}
                />
                <span
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 20,
                    height: 20,
                    minWidth: 20,
                    border: '1.5px solid #fff',
                    borderRadius: 4,
                    backgroundColor: 'transparent',
                    marginRight: 10,
                    color: '#fff',
                    fontSize: 14,
                    lineHeight: 1,
                  }}>
                  {values.rememberMe && '\u2713'}
                </span>
                Se souvenir de moi
              </label>
            </FieldContainer>
            <Submit
              disabled={mutationLoading}
              color="white"
              onClick={handleSubmit}
              style={{width: '100%'}}>
              {mutationLoading ? 'Connexion...' : 'Se connecter'}
            </Submit>
            <div style={{display: 'flex', justifyContent: 'center', width: '100%'}}>
              <span
                role="button"
                tabIndex={0}
                onClick={openForgotPassword}
                onKeyPress={openForgotPassword}
                style={{
                  fontWeight: 'normal',
                  cursor: 'pointer',
                  fontSize: 14,
                  lineHeight: '22px',
                  color: colors.caramel,
                  textDecoration: 'underline',
                }}>
                Mot de passe oublié
              </span>
            </div>
          </FormContainer>
        </LoginMask>
      </LoginBackground>
      {showForgotPassword && <ForgotPasswordModal onClose={closeForgotPassword} />}
    </Container>
  );
};

Login.propTypes = formProps;

export default Login
  |> form({
    ...validate,
    mapPropsToValues: () => ({
      username: '',
      password: '',
      rememberMe: false,
    }),
    handleSubmit: ({username, password}, {props: {postAuth}}) => {
      postAuth({username, password});
    },
  })
  |> withStateHandlers(
    {showForgotPassword: false},
    {
      openForgotPassword: () => () => ({showForgotPassword: true}),
      closeForgotPassword: () => () => ({showForgotPassword: false}),
    },
  )
  |> withProps(({location}) => ({confirmRegister: location?.state?.confirmRegister}))
  |> withRouter
  |> mutate('postAuth');
